import NavbarPrivate from '@/stories/organisms/navbarPrivate/NavbarPrivate';

export const NavBarAuthenticated = () => {
  return (
    <div data-betby-bottom-nav className="fixed z-[100] -bottom-2 pb-2 left-0 right-0 ls:hidden">
      <div className="border-t-2 border-primary-400 bg-black bg-opacity-50 w-screen mx-auto rounded-sm relative backdrop-blur-md">
        <NavbarPrivate />
      </div>
    </div>
  );
};
